import { isMdaeWidgetOptionChangeEvent, updateStateAfterWidgetOptionChange } from "../../../../common_components/mdae-framework";
import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_REPORT_CONFIGURATION } from "../services/get-report-configuration";
import { GET_SIMPLE_CLIENT } from "../services/get-simple-client";
import { GET_AUDIT_GROUPS_FOR_REPORTS } from "../services/get-audit-groups";
import { cloneDeepWith } from "lodash";
export const SET_HEADER_FOOTER_FORM_DATA = "SET_HEADER_FOOTER_FORM_DATA";
export const SET_INTERNAL_PAYER_TOGGLE_VALUE = "SET_INTERNAL_PAYER_TOGGLE_VALUE";

export const defaulTheaderFooterFormData = {
  reportHeader1: '',
  reportHeader2: '',
  reportHeader3: '',
  clientReportFooter: '',
  includeLogoOnReports: false,
  externalReportHeader1: '',
  externalReportHeader2: '',
  externalReportHeader3: '',
  externalClientReportFooter: '',
  externalIncludeLogoOnReports: false
}

const initialState = {
  headerFooterFormData: defaulTheaderFooterFormData,
  clientInfo: {},
  auditGroups: [],
  isInternalConfigEnabled: false,
  isHeaderFooterFormDataValid: true
}

export default function (state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_HEADER_FOOTER_FORM_DATA:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const headerFooterFormData = newState.headerFooterFormData
          ? newState.headerFooterFormData
          : {};
        for (let prop in action.data.headerFooterFormData) {
          headerFooterFormData[prop] = action.data.headerFooterFormData[prop];
        }
        newState = { ...newState, headerFooterFormData: headerFooterFormData };
      }
      return newState;
    case SET_INTERNAL_PAYER_TOGGLE_VALUE:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_REPORT_CONFIGURATION)(action)) {
        return { ...state, headerFooterFormData: defaulTheaderFooterFormData };
      }
      if (isAsyncComplete(GET_REPORT_CONFIGURATION)(action)) {
        const response = action.response;
        return { ...state, headerFooterFormData: response };
      }
      if (isAsyncOperation(GET_SIMPLE_CLIENT)(action)) {
        return { ...state, clientInfo: {} };
      }
      if (isAsyncComplete(GET_SIMPLE_CLIENT)(action)) {
        const response = action.response;
        return { ...state, clientInfo: response };
      }
      if (isAsyncOperation(GET_AUDIT_GROUPS_FOR_REPORTS)(action)) {
        return { ...state, auditGroups: [] };
      }
      if (isAsyncComplete(GET_AUDIT_GROUPS_FOR_REPORTS)(action)) {
        const response = action.response;
        return { ...state, auditGroups: response };
      }
      return state;
    default:
      return state;
  }
}